import { memoize } from './utils/11debdea1ea47c9f720142fb11e53929e0b970176470de43e28a0ed04eb22b90.cfe-internal.js';

var isFirefox = memoize(function () {
  return /firefox/i.test(navigator.userAgent);
});
var isSafari = memoize(function () {
  return Boolean(window.safari);
});

export { isFirefox, isSafari };
